import { useAppSelector } from 'redux/hooks';
import { authSelectors } from 'redux/modules/Authorization';

export const useUserRoleId = (): string | null => {
  const role = useAppSelector(authSelectors.getUserRole);
  return role?.id ? String(role.id) : null;
};
